import React from 'react';
import { Image } from 'rebass';
import { Box } from 'components';
import { styled } from 'themes';

const Avatar = props => {
  return (
    <AvatarWrapper
      {...props}
      width={props.size}
      src={props.src}
      borderRadius={'50%'}
    />
  );
};

const AvatarWrapper = styled(Image)`
  border: 2px solid white;
`;

export default Avatar;
